import { Route } from "react-router-dom";

import { DASHBOARD_ROUTES } from "src/pages/dashboard/constants";

import { DashboardRoute } from "./DashboardRoute";

/** Route tree for the dashboard module, mounted under `/dashboard`. */
export const dashboardRoutes = <Route path={DASHBOARD_ROUTES.root} element={<DashboardRoute />} />;
